export default "__VITE_ASSET__CMohQhd___"